var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import NextLink from 'next/link';
import { Link as ReactLink, LinkPropTypes, } from '@sitecore-jss/sitecore-jss-react';
export const Link = forwardRef((props, ref) => {
    const { field, editable, children, internalLinkMatcher = /^\//g, showLinkTextWithChildrenPresent } = props, htmlLinkProps = __rest(props, ["field", "editable", "children", "internalLinkMatcher", "showLinkTextWithChildrenPresent"]);
    if (!field ||
        (!field.editable && !field.value && !field.href)) {
        return null;
    }
    const value = (field.href
        ? field
        : field.value);
    const { href, querystring, anchor } = value;
    const isEditing = editable && field.editable;
    if (href && !isEditing) {
        const text = showLinkTextWithChildrenPresent || !children ? value.text || value.href : null;
        // determine if a link is a route or not.
        if (internalLinkMatcher.test(href)) {
            return (React.createElement(NextLink, Object.assign({ href: { pathname: href, query: querystring, hash: anchor }, key: "link", locale: false, title: value.title, target: value.target, className: value.class }, htmlLinkProps, { ref: ref }),
                text,
                children));
        }
    }
    // prevent passing internalLinkMatcher as it is an invalid DOM element prop
    const reactLinkProps = Object.assign({}, props);
    delete reactLinkProps.internalLinkMatcher;
    return React.createElement(ReactLink, Object.assign({}, reactLinkProps, { ref: ref }));
});
Link.defaultProps = {
    editable: true,
};
Link.displayName = 'NextLink';
Link.propTypes = Object.assign({ internalLinkMatcher: PropTypes.instanceOf(RegExp) }, LinkPropTypes);
